// extracted by mini-css-extract-plugin
export default {"title":"SNKxq9VNCRvf7YTS2VSa"};